<template>
  <Layout>
    <div class="container">
      <div :style="{ backgroundImage: `url(${banner1url})` }" class="banner">
        <div class="banner-title">
          <div class="title">组织机构 <em>Organization</em></div>
        </div>
      </div>
      <div class="main">
        <div class="content">
          <div
            v-for="(item, index) in  orgImages"
            :key="index"
            class="org-image"
            :class="activeIndx == index ? 'show' : ''"
          >
          <img :src="item.name" alt="" />
          </div>
        </div>
        <div class="navs">
          <div
            v-for="(item, index) in  navTitle"
            :key="index"
            class="nav-item"
            :class="activeIndx == index ? 'active' : ''"
            @click="changeIndex(index)"
          >
            <i class="icon el-icon-arrow-right"></i>
            {{item.name}}
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "./../../components/Layout";
import Footer from "./../../components/Footer";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      banner1url: require("assets/images/news/banner1.png"),
      activeIndx:  this.$route.query.tab ?+this.$route.query.tab: 0,
      navTitle: [
        { name: "联盟领导机构", id: 1 },
        { name: "联盟职能组织", id: 2 },
        { name: "联盟全体成员大会", id: 3 },
      ],
      orgImages: [
        { name: require("assets/images/about/ldjg.jpg"), id: 1 },
        { name: require("assets/images/about/znzz.jpg"), id: 2 },
        { name: require("assets/images/about/qtcy.jpg"), id: 3 },
      ],
    };
  },
  methods: {
    changeIndex(i) {
      this.activeIndx = i;
    },
  },
};
</script>  
<style lang="scss" scoped>
body,
ul,
h2 {
  /*组合选择器*/
  list-style: none; /*清除列表默认样式*/
  padding: 0; /*清除padding*/
  margin: 0;
}
.banner {
  height: 358px;
  position: relative;
  background-size:100%;
  background-repeat: no-repeat;
  .banner-title {
    height: 80px;
    background:url(~../../assets/images/titbg.png) left top no-repeat;
    background-size: 715px 80px;
    background-repeat: no-repeat;
    position: absolute;
    z-index: 3;
    bottom: 0;
    width: 100%;
    .title {
      width: 1400px;
      margin: 0 auto;
      font-size: 28px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
      em{
        font-size: 28px;
        font-family: TimesNewRomanPSMT;
        color: #FFFFFF;
        line-height: 32px;
        padding-left:20px;
        font-style:normal;
      }
    }
  }
}

.main {
  width: 1400px;
  margin: -40px auto 30px;
  background: #fff;
  padding: 70px 40px 30px 55px;
  display: flex;
  position: relative;
  z-index: 2;
  .content {
    width: 1000px;
    img{width:100%}
    .org-image{display:none;}
    .show{display:block;}
  }
}
.navs {
  flex: 0 0 306px;
  margin-left: 60px;
  .nav-item {
    font-size: 20px;
    font-weight: 500;
    line-height: 68px;
    color: #2a2a2a;
    padding-left: 26px;
    background: #F8FBFF;
    box-shadow: 0px -1px 0px 0px #DDDDDD;
    cursor: pointer;
    .icon {
      color: transparent;
    }
    &.active {
      cursor: default;
      color: #fff;
      background: #1064d0;
      box-shadow: 0px -1px 0px 0px #dddddd;
      .icon {
        color: #fff;
      }
      &:hover{color:#fff;}
    }
    &:hover{color:#1064d0;}
  }
}

</style>